import { React } from 'react';
import '../styles/components/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">Portfolio</h3>
            <p className="footer-description">
              A showcase of my projects and professional journey.
            </p>
          </div>
          
          <div className="footer-section">
            <h3 className="footer-title">Connect</h3>
            <div className="social-icons">
              <a href="https://github.com/ikehvictor" target="_blank" rel="noopener noreferrer" className="social-icon">
                <i className="fab fa-github"></i>
              </a>
              <a href="https://www.linkedin.com/in/ikeh-victor-a6777112b/" target="_blank" rel="noopener noreferrer" className="social-icon">
                <i className="fab fa-linkedin"></i>
              </a>
              <a href="https://x.com/viky1222" target="_blank" rel="noopener noreferrer" className="social-icon">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="mailto:victorikeh0@gmail.com" className="social-icon">
                <i className="fas fa-envelope"></i>
              </a>
              <a href="https://wa.me/2349032543740" target="_blank" rel="noopener noreferrer" className="social-icon whatsapp-icon">
                <i className="fab fa-whatsapp"></i>
              </a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} Ikeh Victor. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;